import { HotmartRum } from '@hot-observability-js/react'
import { v4 as uuidv4 } from 'uuid'

import { TRACE_ID_STORAGE_KEY } from './constants'
import type { TraceParams } from './types'

import { AuthUtils } from '../auth'
import { TimeUtils } from '../time'

export default class MonitoringUtils {
  private static _traceId: string

  private static get traceId() {
    if (!MonitoringUtils._traceId) {
      const storedTraceId = localStorage.getItem(TRACE_ID_STORAGE_KEY)

      if (!storedTraceId) {
        const generatedTraceId = uuidv4()
        localStorage.setItem(TRACE_ID_STORAGE_KEY, generatedTraceId)
        MonitoringUtils._traceId = generatedTraceId
      } else {
        MonitoringUtils._traceId = storedTraceId
      }
    }

    return MonitoringUtils._traceId
  }

  static trace({ message, level = 'debug' }: TraceParams) {
    HotmartRum.withScope((scope) => {
      scope.setLevel(level)
      scope.setTag('traceId', this.traceId)

      const expiresAt = AuthUtils.casUser?.expires_at

      if (expiresAt) {
        const expirationDate = TimeUtils.formatTimestamp(expiresAt)
        scope.setExtra('expirationDate', expirationDate)
      }

      HotmartRum.captureMessage(message, level)
    })
  }
}
